import type { AxiosInstance } from 'axios'
import { wrapApiCall } from '@/lib/axios'

export type TenantClient = {
  id: string
  name: string
  logoUrl?: string | null
  status?: string
  dbStatus?: string
  currentPlanId?: string | null
  planExpireAt?: string | null
}

export const isTenantReady = (tenant: TenantClient) =>
  String(tenant.dbStatus ?? '').toUpperCase() === 'READY'

export const TenantClientService = (client: AxiosInstance) => {
  return {
    async getTenants(token?: string): Promise<TenantClient[]> {
      const headers = token ? { Authorization: `Bearer ${token}` } : undefined
      const { data } = await wrapApiCall(() =>
        client.get<TenantClient[]>('/master/tenant-client/tenants', { headers })
      )
      return data ?? []
    },
  }
}
